import {INIT_MEMBER_DETAILS, SET_MEMBER_DATA} from "../actions/actionTypes";

const crashReporter = store => next => action => {
    try {
        if (action.type === INIT_MEMBER_DETAILS || action.type === SET_MEMBER_DATA){
            const memberDetails = (action.type === INIT_MEMBER_DETAILS && window.Farmigo) ? window.Farmigo.memberDetails : action.memberDetails;
            if (memberDetails){
                let userContext = {email: memberDetails.email};
                if (memberDetails.key)
                    userContext.key = memberDetails.key;
                if (typeof Raven !== 'undefined')
                    Raven.setUserContext(userContext);
            }
        }
        return next(action)
    } catch (err) {
        console.error('Caught an exception!', err);
        if (typeof Raven !== 'undefined') Raven.captureException(err, {
            extra: {
                action
            }
        });
        throw err
    }
};

export default crashReporter;


// WEBPACK FOOTER //
// ./src/middlewares/crashReporter.js